import { ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import { useAuth } from '@/composables/useAuth'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import type { RirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'

type AiAxiosVm = {
  $axios: {
    post: (
      url: string,
      data: FormData,
      config?: { timeout: number }
    ) => Promise<{ data: { success?: boolean; message?: string } }>
  }
}

function errorMessage(error: unknown): string | undefined {
  const err = error as { response?: { data?: { message?: string } } }
  return err.response && err.response.data && err.response.data.message
}

export function useDesignRirekishoAiMypr(formatData: RirekishoFormatData) {
  const { vm, message, varuna, site, deviceLib, cookies } = useHostServices()
  const host = vm as unknown as AiAxiosVm
  const { user, isAuthenticated } = useAuth()
  const route = useRoute()

  const fullscreenLoading = ref(false)
  const aiResultView = ref(false)
  const aiResultMyprResult = ref('')

  function getAIMypr() {
    fullscreenLoading.value = true
    const body = new FormData()
    if (isAuthenticated.value && user.value?.uid) {
      body.append('uuid', user.value.uid)
    }
    const eduList = formatData.educationalHistories
    if (eduList && eduList.length > 0) {
      body.append(
        'education',
        String(eduList[eduList.length - 1].description || '')
      )
    } else {
      body.append('education', '')
    }
    body.append('strength', String(formatData.ai_mypr_good || ''))
    body.append('weakness', String(formatData.ai_mypr_bad || ''))
    body.append('hobby', String(formatData.ai_mypr_hobby || ''))
    body.append('future', String(formatData.ai_mypr_wanted || ''))
    body.append('free', String(formatData.ai_mypr_appeal || ''))
    body.append('app_flag', site.appFlag)
    body.append('device_flg', deviceLib.isMobileDevice ? 'SP' : 'PC')
    body.append('version', '3')
    body.append('site_flag', 'r')

    host.$axios
      .post(varuna.endPoints.aiIntroducePr, body, { timeout: 60000 })
      .then((response) => {
        if (response.data.success) {
          aiResultMyprResult.value = String(response.data.message || '')
          aiResultView.value = true
          message({ message: '取得しました', type: 'success' })
        } else {
          message({ message: '失敗しました', type: 'error' })
        }
        fullscreenLoading.value = false
      })
      .catch((error: unknown) => {
        const msg = errorMessage(error)
        if (msg === 'AIの使用回数が上限に達しました。') {
          aiResultView.value = true
        }
        if (msg) {
          message({ message: msg, type: 'error' })
        }
        fullscreenLoading.value = false
      })
  }

  function goYagiprimeRegister() {
    const routeId = route.params.id
    if (typeof cookies.set === 'function') {
      cookies.set(
        '_YAGISH_YAGIPRIME_ROUTE_ID',
        String(routeId) + '#self_introduction',
        null,
        null,
        'localhost'
      )
    }
    location.href = '/yagiprime_register'
  }

  function applyAiResultToMypr() {
    formatData.mypr = aiResultMyprResult.value.replace(/<br>/gi, '\n')
    aiResultView.value = false
  }

  return {
    fullscreenLoading,
    aiResultView,
    aiResultMyprResult,
    getAIMypr,
    goYagiprimeRegister,
    applyAiResultToMypr
  }
}
